import { action } from 'satcheljs';
import type { MailboxInfo } from 'owa-client-types';

const loadFavorites = action('LOAD_FAVORITES', (mailboxInfo?: MailboxInfo) => {
    return {
        mailboxInfo,
    };
});
export default loadFavorites;
